import { createContext } from 'react';

export const zIndexManager = {
  /**
   * Starting base zIndex.
   */
  baseZIndex: 0,
  /**
   * @param value - new value for the baseZindex
   */
  setBaseZIndex: value => {
    zIndexManager.baseZIndex = value;
  },

  /**
   * Method to  get the current baseZI in use.
   */
  getCurrentBaseZIndex: () => zIndexManager.baseZIndex,

  /**
   * Increment zIndex when component is being mounted again and needs higher zIndex.
   */
  incrementBaseZIndex: () => ++zIndexManager.baseZIndex,

  /**
   * Decrement zIndex when component is being un-mounted.
   */
  decrementBaseZIndex: () => --zIndexManager.baseZIndex
};

const IDSContext = createContext(zIndexManager);

/**
 * Utility to allow apps to set starting baseZI.
 */
export const setBaseZIndex = value => {
  zIndexManager.setBaseZIndex(value);
};

export default IDSContext;
